export default "__VITE_ASSET__283eb613__"